<div class="c-mosaik"
    [ngClass]="{'c-mosaik--single-item' : allImages.length <= 1, 'c-mosaik--two-col' : allImages.length > 1 && allImages.length <= 3}">
  <div class="c-mosaik__big" [ngClass]="{'is-1': allImages.length === 1 || videoId}">
    <div class="c-mosaik__item" *ngIf="videoId">
      <youtube-player [width]="'100%'" [height]="'100%'" [videoId]="videoId"></youtube-player>
    </div>
    <div class="c-mosaik__item" (click)="openGallery(null)" *ngIf="!videoId">
      <picture>
        <img class="img-cover" height="400" width="100%" [src]="(allImages[0] | cdnify)" alt="" [showPlaceholderOnError]="true">
      </picture>
    </div>
  </div>
  <ng-container *ngIf="allImages.length || videoId">
    <div class="c-mosaik__small"
         [ngClass]="{'d-none' : allImages.length === 1, 'is-2' : allImages.length <= 3}">
      <div class="c-mosaik__item"
           *ngFor="let image of allImages | slice: 1:8 | limitTo: videoId ? 4 : 5">
        <picture (click)="openGallery(null)">
          <img [src]="(image | cdnify)" alt="" loading="lazy" [showPlaceholderOnError]="true">
        </picture>
      </div>
    </div>
  </ng-container>
  <div class="c-mosaik__cta" *ngIf="allImages?.length > 1">
    <a (click)="openGallery(null)">
      <span class="icon-gallery"></span>
      <span class="c-mosaik__cta-label">Galleria</span>
    </a>
  </div>
</div>
